import { render } from "./EditTrip.vue?vue&type=template&id=1b1e8a8c"
import script from "./EditTrip.vue?vue&type=script&lang=js"
export * from "./EditTrip.vue?vue&type=script&lang=js"

import exportComponent from "/home/joeyd/Documents/Work/Clients/Taxined/Development/TripTrader/triptrader-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__